export enum EnActionType {
    confirm = 'confirm',
    cancel = 'cancel',
    add = 'add',
    delete = 'delete',
}
